import mock from './mock'

import './jwt'
import './select'
import './pages/faq'
import './apps/chat'

import './apps/invoice'
import './apps/calendar'
import './apps/userList'
import './pages/profile'


import './pages/pricing-data'
import './navbar/navbarSearch'


import './cards/card-analytics'
import './cards/card-statistics'
import './pages/account-settings'
import './autoComplete/autoComplete'

mock.onAny().passThrough()
